﻿import Cart from './store/cart';
import Checkbox from './components/checkbox';
import Recaptcha from './components/recaptcha';

import Checkout from './store/Checkout/Checkout';
import CheckoutFlow from './store/Checkout/CheckoutFlow';
import Validation from './components/validation';
import Megamenu from './components/megamenu';
import Teacher from './components/teacher';
import MailingList from './components/mailingList';
import Tabs from './components/tabs';

import VideoPlayer from './components/videoplayer';
import ImageGallery from './components/imageGallery';



require('./utilities/polyfill-ie11-foreach');

require('es6-promise').Promise;

require('./components/blazy.js');
require('./components/accordion.js').initialize();
Checkbox.init();
Recaptcha.init();
Tabs.init();
VideoPlayer.init();

require('./components/courseRegister.js').initialize();
require('./components/courseWaitingList.js').initialize();
require('./components/dropdown.js').initialize();
require('./components/modal.js').initialize();
require('./components/login.js').initialize();
require('./components/monthlySub.js').initialize();
require('./components/monthlyCustomSub.js').initialize();
require('./components/customLogin.js').initialize();
require('./components/register.js').initialize();
require('./components/forgotPassword.js').initialize();
require('./components/resetPassword.js').initialize();
require('./components/receiptModal.js').initialize();
require('./components/loginDialog.js').initialize();
require('./components/quantity.js').initialize();
require('./components/button.js').initialize();
require('./components/breadcrumb.js').initialize();
require('./components/filter.js').initialize();
require('./components/searchPage.js').initialize();
require('./components/productsFilter.js').initialize();
//require('./components/formBoditrax.js').initialize();
require('./components/standardForm.js').initialize();
if (document.querySelector('.auth-form')) {
  // because banner is altered in mobile auth form
  require('./components/authForm.js').initialize();
}
require('./modules/timetable/timetable.js').initialize();
require('./modules/timetable/classRegister.js').initialize();
require('./modules/timetable/classWaitingRegister.js').initialize();
require('./modules/timetable/timetableManager.js').initialize();
require('./modules/timetable/kpiManager.js').initialize();
require('./modules/mypage/mypage.js').initialize();
require('./modules/mypage/mypageUserInfo.js').initialize();
require('./modules/mypage/mypageChangePassword.js').initialize();
require('./modules/mypage/mypageCancelContract.js').initialize();
require('./modules/mypage/mypageUnregister.js').initialize();
require('./modules/mypage/mypageReceipt.js').initialize();

require('./store/chooseYourWay.js');



if (document.querySelector('.klaviyo-postlist-form')) {
  // window._klOnsite = window._klOnsite || [];
  // window._klOnsite.push(['openForm', 'XNm8ck']);

  // takes some time for the klaviyo popup to load into the DOM
  const klaviyoCheckInterval = setInterval(() => {
    const klaviyoPopups = document.querySelectorAll('.klaviyo-form');
    if (klaviyoPopups && klaviyoPopups.length > 0) {
      require('./components/klaviyoPopup.js').initialize(klaviyoPopups);
      clearInterval(klaviyoCheckInterval); // Stop checking once forms are found
    }
  }, 100);
}

const initTeacher = new Teacher();
const initMailingList = new MailingList();

const initValidation = new Validation();

const initCheckout = new Checkout();
const initCheckoutFlow = new CheckoutFlow();

document.querySelectorAll(".product").forEach(target => {
  ImageGallery(target);
});

require('./animation');
